import './blocks/slider/frontend.js'
import './blocks/PostCollection/frontend.js'
import './blocks/events-collection/frontend.js'
import './blocks/event-finder-form/frontend.js'
import './blocks/share-buttons/frontend.js'
import './blocks/course-wizard/frontend.js'